// extracted by mini-css-extract-plugin
module.exports =  {"card-footer":"UUWKVHR","cardFooter":"UUWKVHR"};